<div class="ndvi-chart-container">
  @if (data && data.length > 0) {
    <div class="chart-wrapper">
      <canvas
        baseChart
        [data]="chartConfiguration.data"
        [options]="chartConfiguration.options"
        [type]="chartConfiguration.type"
        (chartClick)="onChartClick($event.event, $event.active || [])"
        class="chart-canvas"
      >
      </canvas>
    </div>
  }

  @if (data && data.length > 0) {
    <div class="chart-controls">
      <div class="chart-info">
        @if (data.length > 1) {
          <span class="date-range">
            <strong>Período:</strong>
            {{ getDateRange() }}
          </span>
        }
      </div>
    </div>
  }

  @if (!data || data.length === 0) {
    <div class="no-data">
      <div class="no-data-icon">📈</div>
      <h3>Nenhum dado disponível</h3>
      <p>Não há dados de NDVI para exibir no gráfico.</p>
    </div>
  }
</div>
